<template>
  <swiper
      :options="swiperOptions"
      v-if="$store.getters['Brand/getBrands'].length > 0"

  >
    <swiper-slide v-for="brand in $store.getters['Brand/getBrands']" :key="brand.id" class="p-2">
      <router-link class="brand-link text-decoration-none"
                   :to="{name: 'Products',
              query: { page: 1, brand: brand.id }}">
        <m-c102 :image="brand.image" :text="brand.name" :alt="brand.name" class="slider-card"/>
      </router-link>

    </swiper-slide>
    <div class="swiper-button-prev" slot="button-prev"></div>
    <div class="swiper-button-next" slot="button-next"></div>
  </swiper>
</template>

<script>
import {Swiper, SwiperSlide} from "vue-awesome-swiper";

export default {
  name: "Slider-100",
  components: {Swiper, SwiperSlide},
  data() {
    return {
      swiperOptions: {
        slidesPerView: 4,
        spaceBetween: 30,
        autoplay: {
          delay: 2000,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        breakpoints: {
          300: {
            slidesPerView: 2,
          },
          480: {
            slidesPerView: 3,
          },
          768: {
            slidesPerView: 4,
          },
          980: {
            slidesPerView: 3,
          },
          1200: {
            slidesPerView: 5,

          },
        },
      },
    };
  },
  mounted() {
    this.$store.dispatch("Brand/getBrands");
  },
};
</script>

<style scoped>

.slider-card {
  height: 100vh;
  max-height: 150px !important;
}

</style>